// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCgAi5YLOQS7-tV6hsCFKNL7y4zL0YZ6c0",
    authDomain: "trayecto-ec.firebaseapp.com",
    databaseURL: "https://trayecto-ec.firebaseio.com",
    projectId: "trayecto-ec",
    storageBucket: "trayecto-ec.appspot.com",
    messagingSenderId: "871136001931",
    appId: "1:871136001931:web:b80e14b5b741cf0798798e",
    measurementId: "G-EGKGYNS5SD"
  },
  nodoAmbiente:"produccionV2"
 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
